import type { ClassCatalogEntry } from '@/features/class/classCatalog';
import type { RegisteredBoard } from '@/features/class/classRegistry';
import { CLASS_DOT_COLORS } from '@/features/class/manage/constants';
import type { ManagedClass } from '@/features/class/manage/types';
import type { OwnedClassCard } from '@/features/profile/types';

/**
 * Build a `ManagedClass` from a runtime-registered board (a real API class
 * discovered from the login `board[]` / joined-boards responses).
 *
 * The registry only knows `{ id, code, name, isPrivate }`, so the richer form
 * fields (class type, academic year, grade level, credits) are left blank for
 * the owner to complete. This lets the edit modal open for real boards instead
 * of silently failing when the id is not part of the seeded manage store.
 */
export function registeredBoardToManagedClass(board: RegisteredBoard): ManagedClass {
  return {
    id: board.id,
    code: board.code || board.id,
    name: board.name,
    classType: 'subject',
    academicYearId: '',
    academicYearLabel: '',
    gradeLevelId: '',
    gradeLevelLabel: '',
    isPrivate: board.isPrivate ?? false,
    archived: board.archived ?? false,
    postCount: 0,
    memberCount: 0,
    dotClassName: CLASS_DOT_COLORS[0],
  };
}

export function managedClassToOwnedCard(item: ManagedClass): OwnedClassCard {
  return {
    id: item.id,
    code: item.code,
    name: item.name,
    postCount: item.postCount,
    memberCount: item.memberCount,
    isPrivate: item.isPrivate,
    dotClassName: item.dotClassName,
  };
}

export function managedClassToCatalogEntry(item: ManagedClass): ClassCatalogEntry {
  return {
    code: item.code,
    name: item.name,
    dotClassName: item.dotClassName,
  };
}
